import axios from 'axios';
import axiosError from '../axios-error.vue';
import loadingAnimation from '../loading-animation.vue';
import collectionHeader from './collection-header.vue';
import quickLinks from './quick-links.vue';
import standardCollectionGrid from './standard-collection-grid.vue';
import { ColorwaySort } from '../enums/collections';
import { cloudinary } from '../mixins/cloudinary';

export default {
  name: 'standardCollectionContainer',
  components: {
    CollectionHeader: collectionHeader,
    QuickLinks: quickLinks,
    StandardCollectionGrid: standardCollectionGrid,
    LoadingAnimation: loadingAnimation,
    AxiosError: axiosError,
  },
  mixins: [cloudinary],
  props: ['collectionId', 'cBanners'],
  data() {
    return {
      isLoading: true,
      error: false,
      sectiondata: {},
      productData: [],
      quickLinkList: [],
      colorwaySort: 'default',
      hideHeroSection: false,
    };
  },
  methods: {
    //get the products
    getCollection() {
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';
      //
      axios
        // if visibility param is provided, call the API with that attached.
        .get(
          targetdomain +
            `/collection/getCollectionByShopifyCollectionId/${this.collectionId}`
        )
        .then((response) => {
          if (response.data.sections) {
            this.sectiondata = response.data.sections;
            if (response.data.sections.showQuickLinks) {
              this.quickLinkList = response.data.sections.quickLinks;
            }
          }
          if (this.sectiondata.colorwayGroupSortOrder) {
            this.colorwaySort = this.sectiondata.colorwayGroupSortOrder;
          }
          if (this.sectiondata.hideHeroSection) {
            this.hideHeroSection = this.sectiondata.hideHeroSection;
          }
          //add cloudinary tranform flags to optimize the photography for bandwidth.
          response.data.products.forEach(product => {
            if(product.alternateImage){
              product.alternateImage.url = this.addImageOptimizationTransforms(product.alternateImage.url, 1200);
            }
          });
          this.productData = response.data.products;

          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          window.location.replace(
            window.location.href + '?view=default'
          );
        });
    },
  },
  mounted() {
    this.getCollection();
  },
};
